import { useEffect } from "react";

// Title is set imperatively via document.title, which updates the SINGLE static
// <title> already present in index.html — so no duplicate <title> is created.
// The meta description uses React 19's native metadata hoisting (exactly one in
// <head>), and React swaps it on route changes.
export const Seo = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return <meta name="description" content={description} />;
};
